
import {map} from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { Observable } from "rxjs";
import "rxjs/Rx";
declare var printJS: any;

import { Baseservice } from './baseservice'

import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PermitService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super("permit", http, authentication);
  }

  get() {
    return this.getPermit(this.url + "/permit");
  }
  getAppPer() {
    return this.getPermit(this.url);
  }

  getById(id: any) {
    return this.getPermit(this.url + "/find/" + id);
  }
  getPermitReturn(id: any) {
    return this.getPermit(this.url + "/return/" + id);
  }
  getPermit(url: string) {
    return this.getRequest(url).pipe(map(response => response));
  }
  copyPermit(id) {
    return this.getPermit(this.url + "/copy/" + id);
  }
  postPermit(object: any) {
    let body = object;
    return this.http.post(this.url, body);
  }
  postAppPermit(object: any, days) {
    let body = object;
    return this.http.post(this.url + '/from-vehicle/' + days, body);
  }
  putAppPermit(object: any, days) {
    if(object.can_specify_duration==true){
      let body = object;
      return this.http.put(this.url + '/update-vehicle/' + days, body);
    }else{
      let body = object;
      return this.http.put(this.url, body);
    }
  }

  deletePermitByPermitNumAndIssueNum(permit_num, permit_issue)
  {
    return this.http.get(this.url + '/delete/latest/' + permit_num + '/' + permit_issue + '/');
  }

  putPermit(object) {
    let body = object;
    return this.update(body);
  }
  upadatePermit(object) {
    let body = object;
    return this.http.put(this.url, body);
  }
  saveToCorspdc(carrier_id: number, username: string) {
    return this.http.get(this.url + '/confirmation/' + carrier_id + '/' + username + '/');
  }
  sendEmail(email: string) {
    return this.http.get(this.url + '/confirmation/' + email + '/');

  }
  sendApproveEmail(body: any) {
    return this.http.post(this.url + '/confirmation-approval/', body);

  }
  //confirmation-approval
  deletePermit(id) {
    return this.http.delete(this.url + '/app/delete/' + id);

  }//delete/route/doc/
  deleteRouteDoc(id) {
    return this.http.delete(this.url + '/app/delete/route/doc/' + id);

  }
  DeletePermitDoc(id: any) {

    return this.http.get(this.url + '/delete-permit/' + id);
  }

  TryPrintOrFail = (Reportname, pId, pNum, username, validFrom, NumOfDays) => {
    const uri = `${this.url}/download/${Reportname}/${pId}/${pNum}/${username}/${validFrom}/${NumOfDays}`;
    printJS({ printable: uri, type: 'pdf', showModal: true, modalMessage: 'Processing your request, please wait...' });

  }
  getPermitForPrint(id){
    return this.http.get(this.url + '/printing-permit/' + id);

  }


  DownloadPDF = (Reportname, pId, pNum, username, validFrom) => {
    const uri = `${this.url}/download/${Reportname}/${pId}/${pNum}/${username}/${validFrom}`;
    //window.location.href= uri;
    window.open(uri, '_blank' // <- This is what makes it open in a new window.
    );

  }


  approvePermitAndSendNotification(carId: number, appId, username = '') {
   return this.getRequest(`${this.url}/send/notification/${carId}/${appId}/${username}`);
  // console.log(`${this.url}/send/notification/${carId}/${appId}/${username}`);
  }

  isPrinted(permId: number) {
    return this.getRequest(`${this.url}/print/locked/${permId}`);
  }
  RenewPermit(object: any) {
    let body = object;
    return this.http.post(`${this.url}/renew`, body);
  }

  getFaceValueNumber(number: string) {
    return this.getRequest(`${this.url}/facenumber?number=${number}`);
  }
  updatePrintCondtions(permit) {
    let body = permit;
    return this.http.put(this.url + "/special-condition", body);
  }
  updateCarrier(carrier) {
    let body = carrier;
    return this.http.put(this.url + "/add/carrier", body);
  }

  SaveValidDate(number, todate, fromdate, passenger_number) {
    return this.getRequest(`${this.url}/validto/${number}/${todate}/${fromdate}/${passenger_number}`);
  }

  getPermitDetails(Id) {
    return this.getRequest(`${this.url}/permitype/${Id}`);
  }

  changeRoute(permId: number, username, is_route) {
    return this.getRequest(`${this.url}/amend/route/${permId}/${username}/${is_route}`);
  }
  changeVehicle(permId: number, username, is_vehicle) {
    return this.getRequest(`${this.url}/replace/vehicle/${permId}/${username}/${is_vehicle}`);
  }
  managePermitCorrection(permId: number) {
    return this.getRequest(`${this.url}/manage/correction/${permId}`);
  }
  corrections(permId: number, username) {
    return this.getRequest(`${this.url}/permit-correction/${permId}/${username}`);
  }

  UpdatePermitNum(permit_id) {
    return this.getRequest(`${this.url}/update/permit/num//${permit_id}`);
  }
  UpdatePermitStatus(permit_id) {
    return this.getRequest(`${this.url}/cancel/status/${permit_id}`);
  }

  checkpermnum(carrierid: number, permittype: number)
  {
    return this.getRequest(this.url + '/checknum/' + carrierid + '/' + permittype);
  }

  getpermappbycarrier(carrierid: number, frieghtpassind: number)
  {
    return this.getRequest(this.url + '/carrierapplist/' + carrierid + '/' + frieghtpassind);
  }
  CheckLatestPermitIssued(permitNumber,issueNumber){
    return this.getRequest(`${this.url}/renewal/${permitNumber}/${issueNumber}`);

  }
  CheckPermitIssued(permitNumber,issueNumber){
    return this.getRequest(`${this.url}/check/latest/${permitNumber}/${issueNumber}`);

  }
  UpdatePreviousPermitsIssued(permitNumber){
    return this.getRequest(`${this.url}/list/${permitNumber}`);

  }
  getAllPermitsByApplicationId(appId){
    return this.getPermit(this.url +"/"+appId);

  }
  GetAllApplicationDetails(permitNumber,renewalNumber){
    return this.getRequest(`${this.url}/details/copy/${permitNumber}/${renewalNumber}`);

  }
  PrintingPermit(body: any) {
    return this.http.post(this.url + '/download/print' ,body, { responseType: 'blob' }).pipe(map((res:any) => {
      return res;
    }));
  }
  PrintingAnneuxre(body: any) {
    return this.http.post(this.url + '/download/print' ,body, { responseType: 'blob' } ).pipe(map((res:any) => {
      return new Blob([res.blob()], { type: 'application/pdf' })
    }));
  }
  PrintingPermitView(body: any) {
    return this.http.post(this.url + '/download-print' ,body, { responseType: 'blob' }).pipe(map((res:any) => {
      return res;
    }));
  }
  ManageDuplicate(permId: number, username){
    return this.getRequest(`${this.url}/permit-duplication/${permId}/${username}`);

  }
}

